var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmallIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 47,
    viewBox: "0 0 52 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter0_f_238_370)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.49074 41.1696C10.4429 34.7382 18.1608 23.9273 33.4146 32.1355",
    stroke: "#E57C1A",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5521 31.125C30.1056 24.8649 29.4781 11.5967 46.5398 8.60488",
    stroke: "#FFDF73",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8512 32.5184C28.1315 32.6636 15.4564 28.6914 18.5125 11.6411",
    stroke: "white",
    strokeWidth: 8
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_238_370",
    x: 0.663208,
    y: 0.664978,
    width: 50.5675,
    height: 45.6664,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_238_370"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallIcon);
export default __webpack_public_path__ + "static/media/smallIcon.19ac225457aa9e46983613bd93cfe808.svg";
export { ForwardRef as ReactComponent };